import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

export const IOSSwitch = withStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
    padding: 0,
    width: 42,
    height: 26,
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#52d869',
        border: 'none',
        opacity: 1,
      },
    },
    '&$focusVisible $thumb': {
      border: '6px solid #fff',
      color: '#52d869',
    },
  },
  thumb: {
    height: 24,
    width: 24,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[400]}`,
    transition: theme.transitions.create(['background-color', 'border']),
    opacity: 1,
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        thumb: classes.thumb,
        switchBase: classes.switchBase,
        checked: classes.checked,
        track: classes.track,
      }}
      {...props}
    />
  );
});
export default IOSSwitch;
